import React from "react"

import ModalV4Header from "../../../../../app/ui/modal/v4/header/v4-header"

export default function Converting() {
    return (
        <>
            <ModalV4Header height={60} title="Converting..."/>

            <div className="main">
                <div className="gd-loading">
                    <img src="/app/web/skin/common/loader/app-loading.gif?3" width={40}/>
                    <p>Converting project. Please wait ...</p>
                </div>
            </div>
        </>
    )
}






